<template>
  <div class="marker-cluster-panel">
    <div
      class="marker-cluster-socialization"
      :class="[getMakerClass]"
      @mouseenter="markerMouseenter"
      @mouseleave="markerMouseleave"
    >
      <span class="text" v-if="!(isMouseOver && typeList && typeList.length >= 1 && getIconType.length >= 1)">{{ clusterInfo.totalNums}}</span>
      <div
        class="hover-box"
        v-show="isMouseOver && typeList && typeList.length >= 1 && getIconType.length >= 1"
      >
        <div
          class="hover-div"
          v-for="(v, i) in getIconType"
          :key="i"
        >
          <div class="hover-div-item">
            <img :src="require(`@/assets/images/socializationIcon/map-icon/icon_${v.type}.png`)" />
            <div class="hover-div-item-num">{{ v.num }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    clusterInfo: {
      type: Object,
      default: () => {},
    },
    // 选择那些类型
    typeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    vmm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isMouseOver: false,
    };
  },
  computed: {
    getMakerClass() {
      if (this.typeList.length == 1 && this.typeList[0] != 8) {
        return "marker-" + this.typeList[0];
      } else {
        return "marker-8";
      }
    },

    // 获取类型以及数量
    getIconType() {
      let iconObj = [];
      if (this.clusterInfo["sellingStationNums"]) {
        iconObj.push({ type: 0, num: this.clusterInfo["sellingStationNums"] });
      }
      if (this.clusterInfo["repairStationNums"]) {
        iconObj.push({ type: 1, num: this.clusterInfo["repairStationNums"] });
      }
      if (this.clusterInfo["transportStationNums"]) {
        iconObj.push({
          type: 2,
          num: this.clusterInfo["transportStationNums"],
        });
      }
      if (this.clusterInfo["materialStationNums"]) {
        iconObj.push({ type: 3, num: this.clusterInfo["materialStationNums"] });
      }
      if (this.clusterInfo["gasStationNums"]) {
        iconObj.push({ type: 4, num: this.clusterInfo["gasStationNums"] });
      }
      if (this.clusterInfo["driverNums"]) {
        iconObj.push({ type: 5, num: this.clusterInfo["driverNums"] });
      }
      if (this.clusterInfo["helperNums"]) {
        iconObj.push({ type: 6, num: this.clusterInfo["helperNums"] });
      }
      if (this.clusterInfo["workNums"]) {
        iconObj.push({ type: 7, num: this.clusterInfo["workNums"] });
      }
      if (this.clusterInfo["grainNums"]) {
        iconObj.push({ type: 9, num: this.clusterInfo["grainNums"] });
      }
      return iconObj;
    },
  },
  methods: {
    markerMouseenter() {
      this.isMouseOver = true;
    },
    markerMouseleave() {
      this.isMouseOver = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.marker-cluster-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
}
.marker-cluster-socialization {
  display: flex;
  align-items: center;
  text-align: center !important;
  color: #ffd695 !important;
  position: relative;
  width: 57px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  .text {
    position: absolute;
    top: -22px;
    font-family: YouSheBiaoTiHei;
    background: #007d43;
    border: 1px solid #00b561;
    font-size: 14px;
    color: #f4fdff;
    line-height: 16px;
    padding: 0 2px;
  }
  .hover-box {
    position: relative;
    background-image: url("../../../assets/images/socializationIcon/map-icon/bg_all.png");
    background-repeat: no-repeat;
    background-size: 100% 66px;
    margin-bottom: 120px;
    z-index: 999999;
  }
  .hover-div {
    display: flex;
    padding: 0 8px;
    height: 58px;
    .hover-div-item {
      display: flex;
      flex-direction: column;
      margin-right: 4px;
      div {
        font-size: 12px;
        color: #ffffff;
        margin: 0;
      }
    }
    .hover-div-item-num {
      padding: 0 10px;
      font-size: 12px;
      color: #ffffff;
      background: rgba(150, 98, 16, 0.59);
      font-weight: 400 !important;
    }
  }
  &.marker-8 {
    // 全部 或 选中 2个以及以上
    background: url("../../../assets/images/socializationIcon/map-icon/icon_map_all.png")
      no-repeat !important;
    background-size: 100% 100%;
    &:hover {
      width: 73px;
      height: 66px;
      background: url("../../../assets/images/socializationIcon/map-icon/icon_map_all_c.png")
        no-repeat !important;
      background-size: 100% 100%;
    }
  }
  &.marker-0 {
    // 经销商
    background: url("../../../assets/images/socializationIcon/map-icon/icon_map_jxs.png")
      no-repeat !important;
    background-size: 100% 100%;
    &:hover {
      width: 73px;
      height: 66px;
      // 经销商选中
      background: url("../../../assets/images/socializationIcon/map-icon/icon_map_jxs_c.png")
        no-repeat !important;
      background-size: 100% 100%;
    }
  }
  &.marker-1 {
    // 维修站
    background: url("../../../assets/images/socializationIcon/map-icon/icon_map_wxz.png")
      no-repeat !important;
    &:hover {
      width: 73px;
      height: 66px;
      // 维修站选中
      background: url("../../../assets/images/socializationIcon/map-icon/icon_map_wxz_c.png")
        no-repeat !important;
      background-size: 100% 100%;
    }
  }
  &.marker-2 {
    // 转运站
    background: url("../../../assets/images/socializationIcon/map-icon/icon_map_zyz.png")
      no-repeat !important;
    &:hover {
      width: 73px;
      height: 66px;
      // 转运站选中
      background: url("../../../assets/images/socializationIcon/map-icon/icon_map_zyz_c.png")
        no-repeat !important;
      background-size: 100% 100%;
    }
  }
  &.marker-3 {
    // 农资站
    background: url("../../../assets/images/socializationIcon/map-icon/icon_map_nzz.png")
      no-repeat !important;
    &:hover {
      width: 73px;
      height: 66px;
      // 农资站选中
      background: url("../../../assets/images/socializationIcon/map-icon/icon_map_nzz_c.png")
        no-repeat !important;
      background-size: 100% 100%;
    }
  }
  &.marker-4 {
    // 加油站
    background: url("../../../assets/images/socializationIcon/map-icon/icon_map_jyz.png")
      no-repeat !important;
    &:hover {
      width: 73px;
      height: 66px;
      // 加油站选中
      background: url("../../../assets/images/socializationIcon/map-icon/icon_map_jyz_c.png")
        no-repeat !important;
      background-size: 100% 100%;
    }
  }
  &.marker-5 {
    // 机手
    background: url("../../../assets/images/socializationIcon/map-icon/icon_map_js.png")
      no-repeat !important;
    &:hover {
      width: 73px;
      height: 66px;
      // 机手
      background: url("../../../assets/images/socializationIcon/map-icon/icon_map_js_c.png")
        no-repeat !important;
      background-size: 100% 100%;
    }
  }
  &.marker-6 {
    // 帮手
    background: url("../../../assets/images/socializationIcon/map-icon/icon_map_bs.png")
      no-repeat !important;
    &:hover {
      width: 73px;
      height: 66px;
      // 帮手选中
      background: url("../../../assets/images/socializationIcon/map-icon/icon_map_bs_c.png")
        no-repeat !important;
      background-size: 100% 100%;
    }
  }
  &.marker-7 {
    // 农活
    background: url("../../../assets/images/socializationIcon/map-icon/icon_map_nh.png")
      no-repeat !important;
    &:hover {
      width: 73px;
      height: 66px;
      // 农活选中
      background: url("../../../assets/images/socializationIcon/map-icon/icon_map_nh_c.png")
        no-repeat !important;
      background-size: 100% 100%;
    }
  }
  &.marker-9 {
    // 农活
    background: url("../../../assets/images/socializationIcon/map-icon/icon_map_lsjjr.png")
      no-repeat !important;
    &:hover {
      width: 73px;
      height: 66px;
      // 农活选中
      background: url("../../../assets/images/socializationIcon/map-icon/icon_map_lsjjr_c.png")
        no-repeat !important;
      background-size: 100% 100%;
    }
  }
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    &.socialization {
      font-family: YouSheBiaoTiHei;
      background: #007d43;
      border: 1px solid #00b561;
      font-size: 14px;
      color: #f4fdff;
      border-radius: 0;
      margin-top: -88px;
      margin-left: -36px;
      padding: 3px;
      // width: 69px;
      height: 16px;
    }
  }
}
</style>